// extracted by mini-css-extract-plugin
export var banner = "_j9-0";
export var closeButton = "_j9-2";
export var greenCheckmark = "_j9-3";
export var hereLink = "_j9-4";
export var titleIcon = "_j9-1";